import script from "./ToothStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ToothStatusModal.vue?vue&type=script&setup=true&lang=js"

import "./ToothStatusModal.vue?vue&type=style&index=0&id=9ffa4bce&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ffa4bce"]])

export default __exports__